import { gql } from '@apollo/client';
import { BasicEventValueFragment } from '../basicEvents/fragments';
import { FieldFieldsFragment } from '../fields';
import { FilterFragment } from '../filters';
import { VirtualEventFragment } from '../virtualEvents';
import { AnyEventFieldsFragment, AnyTableEventFieldsFragment } from './any';

export const EventConditionFieldsFragment = gql`
  fragment EventConditionFields on EventCondition {
    field {
      ...FieldFields
    }
    events {
      ... on AnyEvent {
        ...AnyEventFields
      }
      ... on BasicEventValue {
        ...BasicEventValueFields
      }
      ... on VirtualEvent {
        ...VirtualEventFields
      }
      ... on AnyTableEvent {
        ...AnyTableEventFields
      }
    }
    filter {
      ...FilterFields
    }
  }
  ${AnyEventFieldsFragment}
  ${FieldFieldsFragment}
  ${VirtualEventFragment}
  ${AnyTableEventFieldsFragment}
  ${FilterFragment}
  ${BasicEventValueFragment}
`;
